import store from './store';
import debounce from 'lodash/debounce';
import AuthRepository from './repositories/AuthRepository';
import WebFont from 'webfontloader';
import objectFitImages from 'object-fit-images';
import { getViewData } from './modules/view-data';
import { i18n } from './i18n';


export default {
    el: '#app',

    i18n,

    store,

    data: {
        user: getViewData('user', {
            id: null,
            first_name: null,
            last_name: null,
            email_address: null,
            mobile: null,
        }),
        viewport: 'lg',
    },

    mounted() {
        this.resizeEventTriggers();
        this.loadFonts();

        // Trigger our own custom document ready even to tell plugins
        // when the virtual dom has loaded
        this.$nextTick(() => {
            $(document).trigger('domReady');
            this.resizeEvents();
        });

        const headerEvent = () => {
            const hasPast = $(window).scrollTop() > 100;
            if (this.$store.state.global.scrolledPastNav !== hasPast) {
                this.$store.commit('global/scrolledPastNav', hasPast);
            }
        };
        headerEvent();
        $(window).scroll(headerEvent);

        // fixes click "out" behaviour for some elements on iOS
        $(this.$el).on('click', () => undefined);

        this.moEngageInit();
    },

    methods: {
        /**
         * Set up the triggers for our resize events
         */
        resizeEventTriggers() {
            $(document).on('domReady', () => {
                this.resizeEvents();
                this.$nextTick(this.resizeEvents);
            });
            this.resizeEvents();
            setTimeout(this.resizeEvents, 0); // Let the dom thread catchup
            $(window).resize(debounce(this.resizeEvents));
            window.bus.$on('fixHeaderPadding', this.resizeEvents);

            // Polyfill object-fit
            this.$nextTick(() => objectFitImages('img'));
        },

        /**
         * Load the web fonts we need
         */
        loadFonts() {
            WebFont.load({
                typekit: {
                    id: 'yum6fan',
                },
                custom: {
                    families: [
                        'FontAwesome',
                        'Mont',
                        'YPS App',
                    ],
                    urls: [
                        `${ module.hot ? __webpack_public_path__ : '/dist/app/' }css/fonts.css`,
                    ],
                    testStrings: {
                        'FontAwesome': '\uf240',
                        'YPS App': '\f100',
                    },
                },
            });
        },

        /**
         * Takes an event name string and optional additional data
         * and emits this event via the global event bus
         *
         * @param {string} event - Event name
         * @param {object} [data={}] - Optional event data
         */
        emit(event, data = {}) {
            window.bus.$emit(event, data);
        },

        /**
         * Group resize event handlers so that they are all debounced
         */
        resizeEvents() {
            this.setViewport();
            this.sizeHeaderPadding();
            this.emit('resize');
        },

        /**
         * Size the header padding so that the header never overlaps the content.
         */
        sizeHeaderPadding() {
            // Cache the height
            const isNewHeader = $('body').hasClass('new-header');
            let headerHeight = $('header').outerHeight();
            let elementToPad = isNewHeader ? '.overlay .o .i' : '#main';

            $(elementToPad).css({
                paddingTop: '',
            });

            if (this.$store.getters['listing/isListing'] && this.$route.name !== 'home') {
                headerHeight = 0;
            }

            if (isNewHeader && document.querySelector(elementToPad)) {
                headerHeight += parseFloat(
                    window.getComputedStyle(
                        document.querySelector(elementToPad)
                    ).paddingTop
                );
            }

            // Pad it.
            $(elementToPad).css({
                paddingTop: headerHeight,
            });

            if (!isNewHeader) {
                // Make sure the "List your space" button drops down below the header
                $('header .list-view').css({
                    top: headerHeight - $('header .container').offset().top,
                });
            }
        },

        /**
         * Set a global viewport variable so that individual
         * components don't have to register resize listeners
         * for responsive components
         */
        setViewport() {
            // Cache the width
            const width = $(window).width();

            // Define the breakpoints used in
            // our application
            const breakpoints = {
                xs: 0,
                sm: 768,
                md: 992,
                lg: 1200,
            };

            // Set the smallest breakpoint by default and
            // we'll work our way up
            let viewport = Object.keys(breakpoints)[0];

            Object.keys(breakpoints).forEach((breakpoint) => {
                if (width >= breakpoints[breakpoint]) {
                    viewport = breakpoint;
                }
            });

            this.viewport = viewport;
        },

        /**
         * Log the user in
         *
         * @param formData
         *
         * @returns {Promise}
         */
        login(formData = {}) {
            return AuthRepository.login(formData);
        },

        /**
         * Fetch the users data and sync it with our instance
         *
         * @returns {Promise}
         */
        refreshUserData() {
            return AuthRepository.me(this);
        },

        /**
         * Log the user out
         *
         * @returns {Promise}
         */
        logout() {
            return AuthRepository.logout(this);
        },

        /**
         * Initialize the request for web push notification, save the user id locally and add user info to MoEngage.
         *
         * @param {number} retryCount
         */
        moEngageInit(retryCount = 0) {
            try {
                if (!this.user) {
                    this.$moengage.destroy_session();
                    localStorage.removeItem('moengage_user_id');
                } else {
                    const currentUserId = localStorage.getItem('moengage_user_id');

                    if (currentUserId !== this.user.id) {
                        this.$moengage.add_unique_user_id(this.user.id);
                        this.$moengage.add_first_name(this.user.first_name);
                        this.$moengage.add_last_name(this.user.last_name);
                        this.$moengage.add_email(this.user.email_address);
                        this.$moengage.add_mobile(this.user.mobile);
                        localStorage.setItem('moengage_user_id', this.user.id);
                    }
                }
            } catch (e) {
                if (retryCount < 60) {
                    setTimeout(() => this.moEngageInit(retryCount + 1), 500);
                }
            }
        },
    },
};
